import * as React from 'react';

import { reverb_search_SearchResponse } from '../rql';
import RQLSearchOverview from './rql_search_overview';
import RQLPagination from './rql_pagination';
import RQLFacets from './rql_facets';
import { get } from 'lodash';
import { Filter } from './search_filters';
import { Location } from 'history';

interface IProps {
  error?: boolean;
  loading?: boolean;
  search: reverb_search_SearchResponse;
  location: Location;
  hasFacets?: boolean;
  hasPagination?: boolean;
  hasSearchOverview?: boolean;
  showSearchControls?: boolean;
  // this should be a <Tiles> component of cards
  cards: React.ReactNode;
  fallbackCards?: React.ReactNode;
  followButton?: React.ReactNode;
  followBanner?: React.ReactNode;
  // MarketplaceCSPRow
  relatedSearchRow?: React.ReactNode;
  // FeaturedListing or BumpRow
  highlightedResultRow?: React.ReactNode;
  filters?: Filter[];
  tipText?: string;
  totalText?: string;
  categoryFilters?: React.ReactNode;
  fullWidthCspRow?: boolean;

  // Adds additional sidebar content below the facets
  // This is used in the MarketplaceGrid to display static promos
  sidebarContent?: React.ReactNode;
}

export default class RQLSearchGrid extends React.Component<IProps, null> {
  static defaultProps = {
    hasPagination: false,
    hasFacets: false,
    freeTextQueryParam: '',
    collectionHeader: '',
    relatedSearchRow: null,
    error: false,
    showSearchControls: true,
  };

  filters() {
    return this.props.filters || get(this.props, 'search.filters', []);
  }

  render() {
    return (
      <div className="faceted-grid">
        {this.props.fullWidthCspRow && this.props.relatedSearchRow}
        {this.props.categoryFilters}
        <div className="faceted-grid__inner">
          <div className="faceted-grid__facets">
            {this.props.hasFacets && !this.props.error &&
              <RQLFacets
                filters={this.filters()}
                loading={this.props.loading}
                sidebarContent={this.props.sidebarContent}
              />
            }
          </div>
          <div className="faceted-grid__main">
            {!this.props.fullWidthCspRow && this.props.relatedSearchRow}
            {this.props.hasSearchOverview && !this.props.error &&
              <RQLSearchOverview
                filters={this.filters()}
                followButton={this.props.followButton}
                totalText={this.props.totalText}
                tipText={this.props.tipText}
                loading={this.props.loading}
                showSearchControls={this.props.showSearchControls}
              />
            }
            {this.props.highlightedResultRow &&
              <div className="mtb-gutter">
                {this.props.highlightedResultRow}
              </div>
            }
            {this.props.cards}
            {this.props.hasPagination && !this.props.error && this.props.search &&
              <RQLPagination
                limit={this.props.search.limit}
                total={this.props.search.total}
                offset={this.props.search.offset}
              />
            }
            {!this.props.loading && this.props.followBanner}
            {this.props.fallbackCards}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/rql_search_grid.tsx